import { EXECUTION_MODE, type ExecutionMode } from '@/config/env';

export type { ExecutionMode };

export function getExecutionMode(): ExecutionMode {
    return EXECUTION_MODE;
}

export function isDemoMode(): boolean {
    return getExecutionMode() === 'demo';
}

export function isStagingMode(): boolean {
    return getExecutionMode() === 'staging';
}

export function isProductionMode(): boolean {
    return getExecutionMode() === 'production';
}

export function getExecutionModeLabel(mode: ExecutionMode = getExecutionMode()): 'DEMO' | 'STAGING' | 'LIVE' {
    switch (mode) {
        case 'production':
            return 'LIVE';
        case 'staging':
            return 'STAGING';
        case 'demo':
        default:
            return 'DEMO';
    }
}
